import { useEffect, useState } from "react";
import { api } from "./api";
import { buildFaqJsonLd } from "./seo";

// Centrale veelgestelde vragen (Beheer → FAQ). Eén keer per pagina per sessie opgehaald.
const cache = {};
const load = (page) => {
  const key = page || "*";
  if (!cache[key]) cache[key] = api.get("/faqs", { params: page ? { page } : {} }).then((r) => r.data || []).catch(() => { delete cache[key]; return []; });
  return cache[key];
};
export const refreshFaqs = () => Object.keys(cache).forEach((k) => delete cache[k]);

// Zonder pad: alle vragen die op /veelgestelde-vragen staan. null = nog aan het laden.
export const useFaqs = (page) => {
  const [faqs, setFaqs] = useState(null);
  useEffect(() => {
    let on = true;
    load(page).then((l) => on && setFaqs(l));
    return () => { on = false; };
  }, [page]);
  return faqs;
};

const plain = (t) => t.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
const ld = (list) => (list.length ? buildFaqJsonLd(list.map((f) => ({ q: f.question, a: plain(f.answer) }))) : null);

// Google: een herhaalde vraag maar op één plek markeren. Die plek is /veelgestelde-vragen;
// andere pagina's markeren alleen vragen die uitsluitend daar staan.
export const pageFaqJsonLd = (faqs, path) => ld((faqs || []).filter((f) => !f.on_overview && f.pages?.length === 1 && f.pages[0] === path));
export const overviewFaqJsonLd = (faqs) => ld(faqs || []);
